import { axiosInstance as axios } from "services";

export const fetchSubscriptionDetails = async (companyId) => {
  const { data } = await axios.get(`/admin/subscription/company/${companyId}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to fetch subscription details");
  return data;
};

